import { useState, useEffect } from "react";
import styled from "@emotion/styled";

import { Grid, Button, Card, CardHeader, CardContent, Checkbox, TextField, CardActions, lighten, IconButton } from "@mui/material";

import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';

import { useFormikContext, FieldArray } from "formik";

import AutoCompleteArray from "../../../utils/FormikFields/AutoCompleteArray";

import { capitalize } from "lodash";

import PaidRoundedIcon from '@mui/icons-material/PaidRounded';

import { BasicFlex, LabelUpper } from "../../../utils/Common";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { RowLine, HeaderRowLine, RowField, CheckField, AmountField, ActionField } from "../../../utils/utilities/SelectableTableFields";

import { formatCurrency, formatGenericDate } from "../../../utils/util";

import { getInvoiceAdjustments } from "../../Discounts/apiService";

import useSnackbarStore from "../../../store/snackbar";

import NoItemsFound from "../../../utils/NoItems";

import { displayLabelAdjustment } from "../../../utils/displayLabels";

import CustomAdjustment from "./CustomAdjustment";

const AdjustmentRow = styled(RowLine)`
  background-color: ${props => props.$type === "surcharge" ? lighten(props.theme.colors.success, 0.85) : lighten(props.theme.colors.errorBg, 0.4)};
`;

const Container = styled.div`
  background-color: ${props => props.theme.colors.softBg};
  border-radius: 5px;
  padding: .7rem 1rem;
`

const SearchContainer = styled.div`
  margin: .5rem 0;
`
const AdjustmentListContainer = styled(BasicFlex)`
  margin-top: 1rem;
  width: 100%;
  gap: 1rem;
`;

const StyledCard = styled(BasicFlex)`
 border-radius: 5px;
 border: 1px solid ${props => props.theme.colors.border};
 box-shadow: 0 1px 5px rgba(0, 0, 0, 0.12);
 transition: all 0.2s ease-in-out;
 overflow: hidden;
 padding: 1rem;
 align-items: flex-start;
 
 &:hover {
   border-color: ${props => props.theme.colors.darkBg};
   box-shadow: 0 2px 8px rgba(25, 118, 210, 0.1);
 }
`;

const calculateAdjustmentTotal = (rate, rate_type, adjustment_type) => {
  let rateStr;
  if (rate_type === "percentage") {
    rateStr = `${rate}%`;
  } else {
    rateStr = formatCurrency(+rate);
  }
  if (adjustment_type === "discount") {
    return `-${rateStr}`;
  } else if (adjustment_type === "charge") {
    return `${rateStr}`;
  } 
};

const AdjustmentLine = ({ adjustment, remove, index }) => {
  const { name, description, rate, rate_type, adjustment_type, discount_level, quantity, item_type } = adjustment;
  return (
    <StyledCard>
      <BasicFlex dir="column" gap=".3rem">
        <LabelUpper $size="1rem">Title</LabelUpper>
        <div>{name}</div>
      </BasicFlex>
      <BasicFlex dir="column" gap=".3rem">
        <LabelUpper $size="1rem">Description</LabelUpper>
        <div>{description}</div>
      </BasicFlex>
      <BasicFlex dir="column" gap=".3rem">
        <LabelUpper $size="1rem">Item Type</LabelUpper>
        <div>{capitalize(item_type)}</div>
      </BasicFlex>
      <BasicFlex dir="column" gap=".3rem">
        <LabelUpper $size="1rem">Qty</LabelUpper>
        <div>{quantity}</div>
      </BasicFlex>
      <BasicFlex dir="column" gap=".3rem">
        <LabelUpper $size="1rem">Rate</LabelUpper>
        <div>{rate.toFixed(2)}</div>
      </BasicFlex>
      <BasicFlex dir="column" gap=".3rem">
        <LabelUpper $size="1rem">Total</LabelUpper>
        <div>{calculateAdjustmentTotal(rate, rate_type, item_type)}</div>
      </BasicFlex>
      <IconButton onClick={() => remove(index)}><RemoveCircleOutlineRoundedIcon fontSize="small" color="error" /></IconButton>
    </StyledCard>
  )
}

const Adjustments = ({payment = {}}) => {

  let updates = [
    { name: "adjustment_id", field: "adjustment_id" },
    { name: "title", field: "title" },
    { name: "promo_code", field: "promo_code" },
    { name: "rate", field: "rate" },
    { name: "rate_type", field: "rate_type" },
    { name: "adjustment_type", field: "adjustment_type" },
    { name: "adjustment_level", field: "adjustment_level" }
  ]

  const { values, setFieldValue } = useFormikContext() || {};

  let adjustments = values?.adjustments || [];

  const { data: invoiceAdjustments } = useQuery({
    queryKey: ["adjustments"],
    queryFn: () => getInvoiceAdjustments(),
    staleTime: Infinity
  });

  // useEffect(() => {
  //   if (invoiceAdjustments) {
  //     let filtered = invoiceAdjustments.filter(el => !adjustments.find(adj => adj.adjustment_id === el.adjustment_id));
  //     let selected = filtered.map(el => ({...el, selected: true}));
  //     setFieldValue("adjustments", [...adjustments, ...selected]);
  //   }
  // }, [invoiceAdjustments]);

  return ( adjustments?.length ?
    <Grid size={{xs: 12}}>
      <Container>
        <LabelUpper>Additional Line Items</LabelUpper>
        <FieldArray name="adjustments">
        {({ push, remove }) => (
          <>
          {/* <CustomAdjustment push={push} /> */}
          {adjustments?.length ? <AdjustmentListContainer dir="column">
            {adjustments?.map((el, index) => <AdjustmentLine key={index} index={index} adjustment={el} remove={remove} />)}
          </AdjustmentListContainer> : null}

          {/* {console.log(adjustments, "adjustments")} */}
            {/* <SearchContainer>
              <AutoCompleteArray fieldName="title" name="add_adjustments" label="Search Adjustments" url="adjustments/active" placeholder='Search
              Adjustments' push={push} 
                displayLabel={displayLabelAdjustment}
                additionalFields={{selected: true}} formUpdates={updates}
              />
            </SearchContainer>
            {adjustments?.length ? <BasicFlex dir="column" my="1rem">
              <HeaderRowLine>
                <CheckField></CheckField>
                <RowField $justify="flex-start">Title</RowField>
                <RowField $justify="flex-start">Promo Code</RowField>
                <RowField $justify="flex-start">Level</RowField>
                <RowField $justify="flex-start">Type</RowField>
                <RowField $justify="flex-end">Rate</RowField>
                <RowField $justify="flex-end">Rate Type</RowField>
                <RowField $justify="flex-end">Total</RowField>
                <ActionField $justify="flex-end">Actions</ActionField>
              </HeaderRowLine>
              {adjustments?.map((adjustment, i) => (
                <AdjustmentRow key={adjustment.adjustment_id} $type={adjustment.adjustment_type}>
                  <CheckField><Checkbox size="small" checked={!!adjustment.selected} checkedIcon={<PaidRoundedIcon />} 
                  // onChange={(e) => handleChangeSelect(e, i)} 
                  /></CheckField>
                  <RowField $justify="flex-start">{adjustment.title}</RowField>
                  <RowField $justify="flex-start">{adjustment.promo_code}</RowField>
                  <RowField $justify="flex-start">{adjustment.adjustment_level}</RowField>
                  <RowField $justify="flex-start">{capitalize(adjustment.adjustment_type)}</RowField>
                  <RowField $justify="flex-end">{adjustment.rate?.toFixed(2)}</RowField>
                  <RowField $justify="flex-end">{adjustment.rate_type}</RowField>
                  <RowField $justify="flex-end">{calculateAdjustmentTotal(adjustment.rate, adjustment.rate_type, adjustment.adjustment_type)}</RowField>
                  <ActionField $justify="flex-end">
                    <IconButton size="small" color="error" onClick={() => remove(i)}>
                      <RemoveCircleOutlineRoundedIcon />
                    </IconButton>
                  </ActionField>
                </AdjustmentRow>
              ))}
            </BasicFlex> : <NoItemsFound title="No Adjustments Added" /> } */}
          </>
          )}
        </FieldArray>
      </Container>
    </Grid> : null
  )
};

export default Adjustments;